import { store } from 'quasar/wrappers'
import { createPinia } from 'pinia'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store((/* { ssrContext } */) => {
  const pinia = createPinia()

  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)

  return pinia
})

import {useAccountStore} from './account'
import {useAnalyticsStore} from './analytics'
import {useFormsStore} from './forms'
import {useInvitationStore} from './invitation'
import {useStudioStore} from './studio'
import {useTeamStore} from './team'
import {useUserStore} from './user'
import {useWorkspacesStore} from './workspaces'
import {useAppsumoStore} from "stores/appsumo";

export function resetStores () {
  const stores = [
    useAccountStore(),
    useAnalyticsStore(),
    useFormsStore(),
    useInvitationStore(),
    useStudioStore(),
    useTeamStore(),
    useUserStore(),
    useWorkspacesStore(),
    useAppsumoStore()
  ]
  stores.forEach(s => {
      s.$reset()
    }
  )
}
